import BlobFilePreview from "@/components/BlobPreview";
import { previewPackFile } from "@/lib/api";

/**
 * The preview of one file in a case's document pack, shown by what the file is rather than what its
 * name says. A pack holds files an uploader named and typed, so a `.pdf` that is really `text/html`
 * must never reach a frame; `BlobPreview` decides from the blob's own type. Kept apart from the two
 * dialogs that use it so it carries no Radix component, which the pinned Jest resolver cannot mount.
 *
 * @param {object} props
 * @param {string} props.caseId the collections case the pack belongs to.
 * @param {string} props.fileKey the pack file's key (`up:<id>` for an upload).
 * @param {string} props.name file name.
 * @param {string} props.frameClassName classes for the frame, which differ by dialog.
 * @param {string} [props.frameTestId] test id for the frame.
 *
 * Both dialogs that use it are `h-[85vh]` with a header above the preview, so an image is capped to what
 * is left of that height rather than to `h-full`, which would overflow by the header.
 */
export default function PackFilePreview({ caseId, fileKey, name, frameClassName, frameTestId }) {
  return (
    <BlobFilePreview
      loadKey={`${caseId}:${fileKey}`}
      load={(signal) => previewPackFile(caseId, fileKey, signal)}
      name={name}
      frameClassName={frameClassName}
      frameTestId={frameTestId}
      imageClassName="max-w-full max-h-[calc(85vh-6rem)] object-contain"
      imageWrapperClassName="max-h-[calc(85vh-5rem)] overflow-auto flex items-center justify-center p-4"
      testIdPrefix="pack-preview"
    />
  );
}
